import React from "react";
import { useNavigate } from "react-router-dom";
import { FaComment } from "react-icons/fa";
import { resetApp } from "../../store/actions";
import { useDispatch } from "react-redux";
import ActionButton from "./ActionButton";

const ChatbotButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function resetAndNavigate() {
    dispatch(resetApp());
    navigate("/");
  }

  return (
    <ActionButton
      icon={FaComment}
      tooltip="Chatbot"
      onClick={resetAndNavigate}
    />
  );
};

export default ChatbotButton;
